import { CommonSchemaIds } from './common.const.js';
import { ResellerSchemaIds, ResellerTags } from "./reseller.const.js";
export const RESELLER_TLMD_SCHEMAS = {
    [ResellerSchemaIds.RESELLER]: {
        id: ResellerSchemaIds.RESELLER,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            _id: {
                ref: CommonSchemaIds.UUID,
                required: true,
                usage: [ResellerTags.DEFAULT],
            },
            name: {
                ref: CommonSchemaIds.NAME,
                required: true,
                usage: [{ tag: ResellerTags.DEFAULT }],
            },
            title: {
                ref: CommonSchemaIds.TITLE,
                required: true,
                usage: [{ tag: ResellerTags.DEFAULT }],
            },
            active: {
                ref: CommonSchemaIds.ACTIVE,
                required: true,
                usage: [{ tag: ResellerTags.DEFAULT, input: { create: -1, read: 1, update: 1 } }],
            },
            deleted: {
                ref: CommonSchemaIds.DELETED,
                required: true,
                usage: [{ tag: ResellerTags.DEFAULT, input: { create: -1, read: 1, update: 1 } }],
            },
        },
    }
};
